"use strict";import{tag as r}from"../custom-tag.js";export function notificationIcon({height:t=16,width:i=16,hidden:a=!1,title:l="Notification"}={}){return r`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${i}
      height=${t}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${a?"true":"false"}"
      role="img"
      aria-label="${l}"
    >
      <mask
        id="notification_svg__mask0_6875_6233"
        width="18"
        height="20"
        x="3"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M14.55 19.391C14.55 20.832 13.408 22 12 22s-2.55-1.168-2.55-2.609zM5.2 10.696c0-3.479 3.044-6.957 6.8-6.957s6.8 3.478 6.8 6.957v6.956H5.2z"
        />
        <path
          fill="currentColor"
          d="M10.3 3.74c0-.961.761-1.74 1.7-1.74s1.7.779 1.7 1.74v1.738h-3.4zM3.5 15.913l1.7-1.74h13.6l1.7 1.74v1.74h-17z"
        />
      </mask>
      <g mask="url(#notification_svg__mask0_6875_6233)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=notification.js.map
